module.exports = __webpack_public_path__ + "media/icons/minus@2x-f46de546.png";